import React, { useState } from 'react';
import SyncLoader from 'react-spinners/SyncLoader';

import {
  Container,
  FormContainer,
  Form,
  SubmitButtonContainer,
  SubmitStatus,
  DescriptionContainer,
  DescriptionContent,
  DescriptionSocialContacts,
  SocialContainer,
} from './styles';
import { Ig, Mail } from '../../../../assets/icons';

const Contact: React.FC = () => {
  const [submitStatus, setSubmitStatus] = useState('');
  const [submitting, setSubmitting] = useState(false);

  function submitForm(ev: React.FormEvent<HTMLFormElement>) {
    ev.preventDefault();

    if (submitting) return;

    setSubmitting(true);

    const form = ev.currentTarget;
    const data = new FormData(form);
    const xhr = new XMLHttpRequest();

    xhr.open(form.method, form.action);
    xhr.setRequestHeader('Accept', 'application/json');
    xhr.onreadystatechange = () => {
      if (xhr.readyState !== XMLHttpRequest.DONE) return;

      setTimeout(() => {
        setSubmitStatus('');
      }, 5000);

      setSubmitting(false);

      if (xhr.status === 200) {
        form.reset();
        setSubmitStatus('SUCCESS');
      } else {
        setSubmitStatus('ERROR');
      }
    };
    xhr.send(data);
  }

  return (
    <Container id="contact">
      <FormContainer>
        <h1>FALE COM A GENTE.</h1>
        <span>SINTA-SE A VONTADE PARA NOS ENVIAR UM EMAIL.</span>

        <Form
          onSubmit={submitForm}
          action="https://formspree.io/mnqgrzgr"
          method="POST"
        >
          <input type="text" name="name" placeholder="NOME" />
          <input type="email" name="_replyto" placeholder="E-MAIL" />
          <textarea name="message" placeholder="MENSAGEM" />

          <SubmitButtonContainer>
            {submitStatus === 'SUCCESS' && (
              <SubmitStatus success>Obrigado! Retornaremos logo.</SubmitStatus>
            )}
            {submitStatus === 'ERROR' && (
              <SubmitStatus success={false}>Algo saiu errado!</SubmitStatus>
            )}
            {submitStatus === '' && <SubmitStatus success />}

            <button type="submit">
              {submitting ? <SyncLoader color="#fff" size={10} /> : 'ENVIAR'}
            </button>
          </SubmitButtonContainer>
        </Form>
      </FormContainer>

      <DescriptionContainer>
        <DescriptionContent>
          <p>
            Buscamos sempre entregar o melhor do nosso trabalho. Por isso, sua
            opinião tem grande importância para nós e incentivamos você a entrar
            em contato conosco para nos ajudar nesse processo.
          </p>

          <DescriptionSocialContacts>
            <h2>+55 82 955146-85412</h2>
            <h2>karboncreativestudio@gmail.com</h2>
            <SocialContainer>
              <h1>NOS SIGA NAS REDES SOCIAIS</h1>
              <div>
                <a href="https://www.instagram.com/karbon.creative/">
                  <Ig />
                </a>
                <a href="mailto:karboncreativestudio@gmail.com?subject=Ooopa! Vamos conversar?">
                  <Mail />
                </a>
              </div>
            </SocialContainer>
          </DescriptionSocialContacts>
        </DescriptionContent>
      </DescriptionContainer>
    </Container>
  );
};

export default Contact;

/*
<a href="https://faceboom.com/">
  <Fb />
</a>
<a href="https://twitter.com/">
  <Tt />
</a>
*/
